import { onCLS, onFCP, onLCP, onTTFB, onINP, Metric } from 'web-vitals';

// Types for gtag and dataLayer are already declared in src/types/gtag.d.ts

/**
 * Send Web Vitals metrics to Google Analytics
 * This helps track Core Web Vitals performance over time
 */
function sendToAnalytics(metric: Metric) {
  // Send to Google Analytics if available
  // gtag is declared in src/types/gtag.d.ts as a global Window property
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', metric.name, {
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      event_label: metric.id,
      non_interaction: true,
      // Custom dimensions for better analysis
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
    });
  }

  // Also log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Web Vitals] ${metric.name}:`, {
      value: metric.value,
      delta: metric.delta,
      id: metric.id,
      rating: metric.rating,
    });
  }
}

// Initialize Web Vitals tracking
export function initWebVitals() {
  // Core Web Vitals
  onCLS(sendToAnalytics); // Cumulative Layout Shift
  onINP(sendToAnalytics); // Interaction to Next Paint (replaces deprecated FID)
  onFCP(sendToAnalytics); // First Contentful Paint
  onLCP(sendToAnalytics); // Largest Contentful Paint
  onTTFB(sendToAnalytics); // Time to First Byte
}

// Auto-initialize when module is imported
if (typeof window !== 'undefined') {
  // Wait for page to be interactive before initializing
  if (document.readyState === 'complete') {
    initWebVitals();
  } else {
    window.addEventListener('load', initWebVitals);
  }
}

